/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-31T10:17:51.266
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentRepairFeedBackCleaning,
	listRentRepairFeedBackCleaningInit,
	listRentRepairFeedBackCleaningByAuthorizations,
	deleteRentRepairFeedBackCleaning
} from '@api/rentmanage/RentRepairFeedBackCleaning';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentRepairFeedBackCleaning({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairFeedBackCleaning(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentRepairFeedBackCleaningByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairFeedBackCleaningByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentRepairFeedBackCleaningInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairFeedBackCleaningInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentRepairFeedBackCleaning({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentRepairFeedBackCleaning({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
